module.exports = __webpack_public_path__ + "static/media/07B.b6449522.png";